// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"
import "trix"
import "@rails/actiontext"
import "./routes"
// Ensure Leaflet and its polyline decorator plugin are available globally
import "leaflet"
import "leaflet-polylinedecorator"

// Load LottieFiles dotlottie-web globally to prevent multiple loading
import { DotLottie } from "@lottiefiles/dotlottie-web"

// Make DotLottie available globally
window.DotLottie = DotLottie
